module.exports = __webpack_public_path__ + "static/img/huanzhe1.d1e9520f.png";